import React, { useState, useEffect } from "react"
import './App.css';
import { Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { BrowserRouter } from 'react-router-dom';
import * as Msal from "msal";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import PlatformDashboard from './components/PlatformDashboard';
import ViewClient from './components/ViewClient';
import ClientDashboard from './components/ClientDashboard';
import SendNotification from './components/SendNotification';
import ViewSkills from './components/ViewSkills';
import AddClient from './components/AddClient';
import ViewClientSkills from "./components/ViewClientSkills";
import ClientSkills from "./components/ClientSkills";
import ViewUsers from './components/ViewUsers'
import getConfig from './configs/config'
import Header from './components/Header';
import { getLoggedInUserDetails, getRolesDetails } from './utils/Api';
import Loader from "./components/Loader";
import { toast } from 'react-toastify';
import ViewClientUser from "./components/ViewClientUser";
import Offline from "./components/Offline";
import DelegatedUser from "./components/DelgatedUser";

import DataCatalogue from "./pages/DataCatalogue/DataCatalogue";
import GaldermDataCatalogue from "./pages/GaldermaDataCatalogue/GaledermaDataCatalogue";
import MedHome from "./pages/MedHome/MedHome";
import MedinfoDashboard from "./pages/MedinfoDashboard/MedinfoDashboard";
import GaldermaHome from "./pages/GaldermaHome/GaldermaHome";
import GaldermaDashboard from "./pages/GaldermaDashboard/GaldermaDashboard";

const loginConfig = getConfig()

function App() {

  const [loggedInUserName, setLoggedInUserName] = useState('');
  const [usePlatformAdminRoutes, setUsePlatformAdminRoutes] = useState(false);
  const [useClientAdminRoutes, setUseClientAdminRoutes] = useState(false);
  const [useMedinfoAdminRoutes, setUseMedinfoAdminRoutes] = useState(false);
  const [useGaldermaAdminRoutes, setUseGaldermaAdminRoutes] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);



  const mSALObj = new Msal.UserAgentApplication(loginConfig.msalConfig);

  const handleRedirectCallback = async () => {
    return await mSALObj.handleRedirectCallback(authRedirectCallBack);
  }

  const authRedirectCallBack = async (error, response) => {
    if (error) {
      if (error.errorMessage.indexOf("AADB2C90118") > -1) {
        try {
          await mSALObj.loginRedirect(loginConfig.b2cPolicies.authorities.forgotPassword);
        } catch (err) {
        }
      }
    }
  }

  useEffect(() => {

    function handleOnline() {
      setIsOnline(true);
    }

    function handleOffline() {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    handleRedirectCallback();

    (async () => {
      try {

        const accountDetails = mSALObj.getAccount();
        const isLoggedIn = accountDetails ? true : false;

        if (isLoggedIn) {

          let emailId = accountDetails.idToken.emails[0];
          const ssoRequest = { loginHint: emailId };
          const response = await mSALObj.ssoSilent(ssoRequest);
          sessionStorage.setItem('token', response['idToken']['rawIdToken']);
          let loggedInUser = await getLoggedInUserDetails(accountDetails['idToken']['sub']);
          if (!loggedInUser) {
            toast.info('User not found contact administrator');
            return;
          }

          if (loggedInUser['user_roles'][0]['roles']['role_key'] == 'PLATFORM_ADMIN') {
            setUsePlatformAdminRoutes(true);

          }
          else if (loggedInUser['user_roles'][0]['roles']['role_key'] === 'CUSTOMER_ADMIN' && (loggedInUser['customer_id'] == '22' || loggedInUser['customer_id'] == '7' ||  loggedInUser['customer_id'] == '3' ) )
          {
            setUseMedinfoAdminRoutes(true);
          }
          // Showing Galderma Dashboard to Dev and Prod Galderma Customer
          else if (loggedInUser['user_roles'][0]['roles']['role_key'] === 'CUSTOMER_ADMIN' && (loggedInUser['customer_id'] == '23') ||loggedInUser['customer_id'] == '4' )
          {
            setUseGaldermaAdminRoutes(true);
          }
          else if (loggedInUser['user_roles'][0]['roles']['role_key'] == 'CUSTOMER_ADMIN') {
            setUseClientAdminRoutes(true);
          }

          setLoggedInUserId(loggedInUser['customer_id']);
          setLoggedInUserName(loggedInUser['first_name'] + ' ' + loggedInUser['last_name']);
          localStorage.setItem('userDetail', JSON.stringify(loggedInUser));
          if (!localStorage.getItem('roleDetail') && loggedInUser['user_roles'][0]['roles']['role_key'] == 'PLATFORM_ADMIN') {
            let roleDetail = await getRolesDetails(loggedInUser['id']);
            localStorage.setItem('roleDetail', JSON.stringify(roleDetail));
          }
        } else {
          mSALObj.loginRedirect(loginConfig.loginRequest);
        }
      }
      catch (exception) {
        localStorage.clear();
        sessionStorage.clear();
        mSALObj.logout()
      }
    })();


    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [])

  return (
    isOnline ? (
      loggedInUserId ? (
        <div className='container-fluid p-0 layout-container d-flex justify-content-center p-3'>
          <Loader></Loader>
          <ToastContainer />
          <div className='content-container'>
            <Header mSALObj={mSALObj} loggedInUserName={loggedInUserName}></Header>
            <main className='platform-container p-4 mt-3'>
              <BrowserRouter>
                <Routes>
                  {
                    usePlatformAdminRoutes &&
                    <>
                      <Route path='/' element={<PlatformDashboard />} />
                      <Route path='/offline' element={<Offline />} />
                      <Route path='/platform-dashboard' element={<PlatformDashboard />} />
                      <Route path='/view-client/:id' element={<ViewClient />} />
                      <Route path='/master-skills' element={<ViewSkills />} />
                      <Route path='/new-client' element={<AddClient />} />
                      <Route path='/view-client/:id/skills' element={<ViewClientSkills />} />
                      <Route path='/view-client/:id/users' element={<ViewUsers />} />
                      <Route path='/send-notification' element={<SendNotification />} />

                    </>
                  }
                  {
                    useClientAdminRoutes &&
                    <>
                      <Route path='/' element={<ClientDashboard userId={loggedInUserId} />} />
                      <Route path='/client-dashboard' element={<ClientDashboard userId={loggedInUserId} />} />
                      <Route path='/view-client-user/:id/users' element={<ViewClientUser />} />
                      <Route path='/view-client-user/:id/skills' element={<ClientSkills />} />
                      <Route path='/client-delegated-user/:id' element={<DelegatedUser/>}/>
                    </>
                  }
                  {
                    useMedinfoAdminRoutes &&
                    <>
                         <Route path='/' element={<MedHome userId={loggedInUserId} />} ></Route>
                         {/* <Route path='/dashboard' element={<MedinfoDashboard />} ></Route> */}
                         <Route path='/data-catalogue' element={<DataCatalogue />} />
                         <Route path='/dashboard' element={<MedinfoDashboard />} />
                    </>
                  }
                   {
                    useGaldermaAdminRoutes &&
                    <>
                         <Route path='/' element={<GaldermaHome userId={loggedInUserId} />} ></Route>
                         <Route path='/data-catalogue' element={<GaldermDataCatalogue />} />
                         <Route path='/dashboard' element={<GaldermaDashboard />} />
                    </>
                  }
                </Routes>
              </BrowserRouter>
            </main>
          </div>
        </div>
      ) : (
        <div></div>
      )
    ) : (
      <Offline />
    )
  );
}

export default App;
